module.exports = __webpack_public_path__ + "static/use-case-4-content-3-9d91670bea49a3ebb2afe32fcc8a1500.png";